import template from './template.html';
import controller from './controller';

const userReportState = {
  url: '/report',
  stateName: 'Report',
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    'a@app': {
      template,
      controller,
      controllerAs: 'reportCtrl'
    }
  }
};

const adminReportState = {
  url: '/report',
  stateName: 'Employee Reports',
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    a: {
      template,
      controller,
      controllerAs: 'reportCtrl'
    }
  }
};

export { userReportState, adminReportState };



// WEBPACK FOOTER //
// ./src/app/controllers/users/report/index.js